import React from 'react';

interface DonationSuccessProps {
  onDonateClick: (e: React.MouseEvent) => void;
}

const DonationSuccess: React.FC<DonationSuccessProps> = ({ onDonateClick }) => {
  return (
    <section 
      id="hero" 
      className="gm-about-section"
      style={{
        backgroundImage: 'url(/images/IMGL8960-min-scaled.jpg)'
      }}
    >
      <div className="gm-hero-inner">
        <div className="gm-hero-content">
          <h2>
            Thank You for Your Generous Donation  
          </h2>
          
          <h3>
          Your contribution is a beacon of hope and a powerful force for change. We deeply appreciate your support in our mission to eliminate malaria in southern Africa. Your donation is not just a transaction; it's a lifeline for those in need.
          </h3>
          
        </div>
      </div>
    </section>
  );
};

export default DonationSuccess;
